<template>
  <lateral-modal
    :title="$t('budgets_new_budget_header')"
    @close="closeModal"
  >
    <template slot="content">
      <form
        class="Form px-2"
        id="budget-settings-form"
        @submit.prevent="submit"
      >
        <div class="row">
          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label u-required"> {{ $t('budgets_new_budget_budget_name').toUpperCase()}}</label>
              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.budgetSettings.name.$error}"
                v-focus-input
              >
                <input
                  class="Input-text"
                  type="text"
                  @blur="$v.budgetSettings.name.$touch()"
                  v-model="budgetSettings.name"
                  :placeholder="$t('budgets_new_budget_budget_name')"
                >
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label u-required">{{$t('budgets_new_budget_budget_limit').toUpperCase()}}</label>
              <div
                @click="limitEditFlag= true"
                class="Form-field required"
                :class="{'Form--field-error' : $v.budgetSettings.goal.$error}"
                v-focus-input
              >
                <currency-input
                  :class="'Input-text'"
                  @blur="$v.budgetSettings.goal.$touch() "
                  v-model="budgetSettings.goal"
                  :allow-negative="false"
                ></currency-input>
              </div>

            </div>
          </div>
        </div>
        <div class="row d-flex flex-column px-3">
          <div class="Bugdets-itmBody d-flex justify-content-between">
            <div
              class="Budgets-th Budget-th--black Budgets-th--dot"
              v-t.preserve="{path : 'budgets_budget_goal_limit'}"
            ></div>
            <div
              class="Budgets-th Budgets-th--black ellipsis"
              v-tooltip="budgetSettings.goal"
            >{{budgetSettings.goal | currency('€', 2, {symbolOnLeft:false, thousandsSeparator: '.', decimalSeparator :','})}}</div>
          </div>
          <div class="Bugdets-itmBody d-flex justify-content-between">
            <div
              class="Budgets-td Budgets-td--dot Budgets-td--dot--black"
              v-t.preserve="{path:'budgets_budget_assigned'}"
            ></div>
            <div
              class="Budgets-td ellipsis"
              v-tooltip="budgetSettings.assigned"
            >{{budgetSettings.assigned | currency('€', 2, {symbolOnLeft:false, thousandsSeparator: '.', decimalSeparator :','}) }}</div>
          </div>
          <div class="Bugdets-itmBody d-flex justify-content-between">
            <div
              class="Budgets-td Budgets-td--dot Budgets-td--dot--blue"
              v-t.preserve="{path: 'budgets_budget_spent'}"
            ></div>
            <div
              class="Budgets-td ellipsis"
              v-tooltip="budgetSettings.spent"
            >{{budgetSettings.spent | currency('€', 2, {symbolOnLeft:false, thousandsSeparator: '.', decimalSeparator :','}) }}</div>
          </div>
          <budget-progress-bar
            :spent="budgetSettings.spent"
            :assigned="budgetSettings.assigned"
            :goal="budgetSettings.goal"
          > </budget-progress-bar>

        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label"> {{$t('budgets_new_budget_expiration').toUpperCase()}}</label>
              <date-picker-input
                :mode="'single'"
                :value="new Date(budgetSettings.expirationDate)"
                :placeholder="'date_picker_input_expiration_date_select_default_date'"
                @inputDate="setBudgetExpirationDate"
              ></date-picker-input>
            </div>
          </div>

        </div>
        <div class="row">

          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label u-required"> {{$t('budgets_new_budget_review_flow').toUpperCase()}}</label>
              <div
                class="multiselect-custom-field"
                v-focus-input
              >
                <multiselect
                  :options="reviewFlowOptions"
                  id="'budget-cycle-selector'"
                  :searchable="false"
                  track-by="id"
                  :showLabels="false"
                  :label="'name'"
                  :placeholder="$t('MULTISELECT_DEFAULT_SELECT_LABEL')"
                  disabled
                  v-model="budgetFlow"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>

                  <template v-slot:noOptions>
                    <span>{{$t('multiselect_no_options_slot_default')}}</span>
                  </template>
                </multiselect>
              </div>
            </div>

          </div>
        </div>
        <div v-if="officeFeatureBudgetFields">
          <div class="row">
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label class="form--label"> {{$t('export_fields_budgetField1Label').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    class="Input-text"
                    type="text"
                    v-model="budgetSettings.budgetField1"
                    :placeholder="$t('export_fields_budgetField1Label')"
                  >
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label class="form--label"> {{$t('export_fields_budgetField2Label').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    class="Input-text"
                    type="text"
                    v-model="budgetSettings.budgetField2"
                    :placeholder="$t('export_fields_budgetField2Label')"
                  >
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label class="form--label"> {{$t('export_fields_budgetField3Label').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    class="Input-text"
                    type="text"
                    v-model="budgetSettings.budgetField3"
                    :placeholder="$t('export_fields_budgetField3Label')"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </template>
    <template slot="footer">
      <button
        class="Fuell-Button block blue"
        type="submit"
        form="budget-settings-form"
        :disabled="isSubmitting || !canBeSubmitted"
        v-t.preserve="{path:'ACTION_SAVE'}"
      ></button>
    </template>
  </lateral-modal>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import DatePickerInput from '@/components/Commons/Forms/DatePickerInput'

import BudgetProgressBar from '../_shared/BudgetProgressBar'
import { CurrencyInput } from 'vue-currency-input'
import { isEqual } from 'lodash-es'
import { segmentTrack } from '@/analytics/segment'
import Multiselect from 'vue-multiselect'
import LateralModal from '@/components/Commons/Modals/LateralModal'
const { validationMixin } = require('vuelidate')
const { required, minValue } = require('vuelidate/lib/validators')
export default {
  name: 'BudgetSettingsModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: { DatePickerInput, BudgetProgressBar, CurrencyInput, Multiselect, LateralModal },
  data () {
    return {
      displayGoal: '',
      isSubmitting: false,
      budgetSettings: {
        name: '',
        goal: 0,
        spent: 0,
        budgetCycle: { id: 0 },
        expirationDate: '',
        budgetField1: null,
        budgetField2: null,
        budgetField3: null
      },
      budgetFlow: {},
      originalBudgetSettings: {}
    }
  },
  computed: {
    officeFeatureBudgetFields () {
      return this.$store.getters['CompanyStore/currentCompany']?.activatedFeatures?.find(item => item.feature.code === 'SHOW_BUDGET_FIELDS')
    },
    budgetCycleList () {
      return this.$store.getters['ConfigStore/privateConfig'].budget_cycle || []
    },
    budgetExpirationDate () {
      if (this.currentBudget && this.currentBudget.expirationDate) {
        const properExpirationDate = this.currentBudget.expirationDate.split('T')[0]
        return this.$moment.utc(properExpirationDate).format('YYYY-MM-DD')
      }
      return ''
    },
    currentBudget () {
      return this.$store.getters['BudgetsStore/currentBudget'] || false
    },
    spentPercent () {
      return (this.budgetSettings.spent * 100) / this.budgetSettings.goal
    },
    assignedPercent () {
      const assigned = (this.budgetSettings.assigned * 100) / this.budgetSettings.goal
      return assigned - this.spentPercent
    },
    goalPercent () {
      return 100 - this.assignedPercent - this.spentPercent
    },
    spentPercentStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${this.spentPercent}%`
      }
    },
    assignedPercentStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${this.assignedPercent}%`
      }
    },
    goalPercentStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${this.goalPercent}%`
      }
    },
    hasLocalChanges () {
      return JSON.stringify(this.budgetSettings) !== JSON.stringify(this.originalBudgetSettings)
    },
    canBeSubmitted () {
      return !this.$v.$invalid && this.hasLocalChanges
    },
    reviewFlows () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/reviewFlows'] || []
    },
    fakeDefaultFlow () {
      return {
        id: 'default',
        name: this.$i18n.t('budgets_new_budget_fuell_default_review_flow'),
        code: 'FUELL_DEFAULT_FLOW'
      }
    },
    reviewFlowOptions () {
      return [this.fakeDefaultFlow, ...this.reviewFlows]
    },
    defaultReviewFlow () {
      return this.reviewFlows.find(el => el.byDefault) || false
    }

  },
  methods: {
    _initialize () {
      if (this.currentBudget) {
        this.budgetSettings.name = this.currentBudget.name || ''
        this.budgetSettings.goal = this.currentBudget.goal || 0
        this.budgetSettings.assigned = this.currentBudget.assigned || 0
        this.budgetSettings.spent = this.currentBudget.spent || 0
        this.budgetSettings.budgetCycle.id = this.currentBudget && this.currentBudget.budgetCycle ? this.currentBudget.budgetCycle.id : 0
        this.budgetSettings.expirationDate = this.budgetExpirationDate || ''
        this.budgetSettings.budgetField1 = this.currentBudget.budgetField1
        this.budgetSettings.budgetField2 = this.currentBudget.budgetField2
        this.budgetSettings.budgetField3 = this.currentBudget.budgetField3
        this.originalBudgetSettings = { ...this.budgetSettings }
        this.originalBudgetSettings['budgetCycle'] = { ...this.budgetSettings.budgetCycle }
        this.budgetFlow = this.currentBudget?.flow?.id ? this.currentBudget.flow : this.fakeDefaultFlow
      }
    },
    setBudgetCycle (cycleType) {
      if (!cycleType) return
      cycleType === 'monthly' ? this.budgetSettings.budgetCycle['id'] = 1 : this.budgetSettings.budgetCycle['id'] = 2
    },

    submit () {
      if (this.budgetSettings && !this.isSubmitting) {
        this.isSubmitting = true
        let updatedBudget = {}
        for (let key in this.budgetSettings) {
          if (this.budgetSettings[key]) {
            if (key === 'budgetCycle') {
              updatedBudget[key] = this.budgetSettings.budgetCycle
            } else {
              updatedBudget[key] = this.budgetSettings[key]
            }
          }
          // Force to submit date in case is removed
          if (key === 'expirationDate') {
            updatedBudget[key] = this.budgetSettings.expirationDate ? this.budgetSettings.expirationDate : null
          }
        }

        if (Object.keys(updatedBudget).length === 0 && updatedBudget.constructor === Object) return
        const originalBudget = Object.assign({}, this.currentBudget)

        this.$store.dispatch('BudgetsStore/updateBudget', { budgetId: this.currentBudget.id, budgetUpdateInformation: updatedBudget, originalBudget: this.currentBudget }).then(
          () => {
            const updatedFrequency = updatedBudget.budgetCycle.id === 1 ? 'monthly' : 'one-time'
            const { budgetCycle, expirationDate, goal, name } = originalBudget

            let budgetToCompare = {
              budgetCycle: { id: budgetCycle ? budgetCycle.id : '' },
              expirationDate: expirationDate ? expirationDate.split('T')[0] : null,
              goal: goal,
              name: name
            }
            segmentTrack('Budget settings changed', {
              budget_id: originalBudget.id,
              budget_updated: !isEqual(updatedBudget, budgetToCompare),
              budget_name: originalBudget.name !== updatedBudget.name ? updatedBudget.name : '',
              budget_limit: originalBudget.goal !== updatedBudget.goal ? updatedBudget.goal : '',
              budget_frequency: originalBudget.budgetCycle.id !== updatedBudget.budgetCycle.id ? updatedFrequency : '',
              budget_expiration: (expirationDate && expirationDate.split('T')) !== updatedBudget.expirationDate ? this.$moment.utc(updatedBudget.expirationDate).format('DD/MM/YYYY hh:mm') : ''
            })
            this.isSubmitting = false
            this.closeModal()
          }
        )
      }
    },

    setBudgetExpirationDate (event) {
      this.budgetSettings.expirationDate = event
    }
  },
  created () {
    this._initialize()
  },
  validations: {
    budgetSettings: {
      name: { required },
      goal: { required, minValue: minValue(1) }
    }
  },
  watch: {
    'budgetSettings.goal': function (newV) {
      if (newV) {
        this.budgetSettings.goal = Number.parseFloat(newV)
      }
    }
  }

}
</script>

<style scoped>
.Radiobutton {
  border-radius: 15px;
}
.Radiobutton--selected:after {
  border-radius: 15px;
  width: 8px;
  height: 8px;
  left: 3px;
  top: 3px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
